import LottoContract from "../build/contracts/Lotto.json"
import { derived } from 'svelte/store'
import { web3, chainId } from 'svelte-web3'

const myContractStore = derived([web3, chainId], ([$web3, $chainId]) => {
  if ($chainId && $web3.eth) {
    // Do whatever nececessay to get address from chainId
    let address = LottoContract.networks[$chainId].address
    return new $web3.eth.Contract(LottoContract.abi, address, {})
  }
  return null
})

export default myContractStore
